module.exports = __webpack_public_path__ + "hashed/assets/loading.bd0fb75b.gif";